import client from '../httpClient';

const flyerSalesGetResponseTreeApi = (params) => {
  return client.get('/divisions/flyer-sales-tree/', { params });
};

export default flyerSalesGetResponseTreeApi;
